import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';
import '@/styles/app.css';

const AsyncLoaderWrapper = styled.div`
  align-self: center;
  line-height: 1;
  margin-right: 1rem;
  text-align: center;
  vertical-align: middle;
  display: flex;
  padding: 8px 12px;
`;

const AsyncLoader = (props) => (
  <AsyncLoaderWrapper>
    <Spin />
  </AsyncLoaderWrapper>
);

export default AsyncLoader;